import React from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';

export const EditRubricSectionThread: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <Spacing size="gap-8" direction="horizontal" className="pr-[72px]">
      <div className="rounded-[100px] w-1 bg-gray-200 ml-8"></div>
      {children}
    </Spacing>
  );
};
